module.exports = __webpack_public_path__ + "static/media/email-illustration.65a8dff6.svg";